<template>
  <div>
    <VSection large label="transactions.price_calculation_headline">
      <div class="row">
        <div v-for="{ label, field } in types" :key="label" class="col-l-6 col-m-12">
          <VSection level="5" :label="`transactions.${label}`">
            <VDescriptionList>
              <VEntryNumber
                :currency-field="`${field}.currency`"
                :digits="6"
                :data="transactionDetails"
                :field="`${field}.gross`"
                name="common.gross_amount_label"
              />
              <VEntryNumber
                :currency-field="`${field}.currency`"
                :digits="6"
                :data="transactionDetails"
                :field="`${field}.net`"
                name="common.net_amount_label"
              />
              <VEntryNumber
                :currency-field="`${field}.currency`"
                :digits="6"
                :data="transactionDetails"
                :field="`${field}.tax`"
                name="common.tax_amount_label"
              />
              <VEntryNumber :digits="6" :data="transactionDetails" :field="`${field}.taxRate`" suffix=" %" name="common.tax_rate_label" />
            </VDescriptionList>
          </VSection>
        </div>
      </div>
    </VSection>

    <template v-if="isExpertMode && transactionDetails && transactionDetails.discountInfo">
      <div class="row">
        <div class="col-l-12 col-m-12">
          <VSection level="5" label="transactions.discount_information_headline">
            <VDescriptionListDivided>
              <VGroup label="transactions.discount_information_discount_price_headline">
                <VEntryNumber
                  currency-field="currency"
                  :digits="6"
                  :data="transactionDetails"
                  field="discountInfo.discountedPriceGross"
                  name="common.gross_amount_label"
                />
                <VEntryNumber
                  currency-field="currency"
                  :digits="6"
                  :data="transactionDetails"
                  field="discountInfo.discountedPriceNet"
                  name="common.net_amount_label"
                />
                <VEntryNumber
                  currency-field="currency"
                  :digits="6"
                  :data="transactionDetails"
                  field="discountInfo.discountedPriceTax"
                  name="common.tax_amount_label"
                />
                <VEntryNumber suffix=" %" :data="transactionDetails" field="discountInfo.discountedPriceTaxRate" name="common.tax_rate_label" />
                <VEntry :data="transactionDetails" field="discountInfo.discountedPriceTaxType" name="transactions.taxType" />
              </VGroup>
              <VGroup label="transactions.discount_information_discount_amount_headline">
                <VEntryNumber
                  currency-field="currency"
                  :digits="6"
                  :data="transactionDetails"
                  field="discountInfo.discountValueNet"
                  name="transactions.discount_information_discount_amount_net_amount_label"
                />
              </VGroup>
              <VGroup label="transactions.discount_information_percentaged_discount_headline">
                <VEntryNumber
                  suffix=" %"
                  :data="transactionDetails"
                  field="discountInfo.discountPercentage"
                  name="transactions.discount_information_percentaged_discount_discount_rate_label"
                />
              </VGroup>
              <VGroup label="transactions.discount_information_internal_information_headline">
                <VEntryNumber
                  suffix=" %"
                  :data="transactionDetails"
                  field="discountInfo.transcationCalcPerCent"
                  name="transactions.discount_information_internal_information_calculated_percentage_label"
                />
                <VEntry
                  :data="transactionDetails"
                  field="discountInfo.transcationDiscountApplied"
                  boolean
                  name="transactions.discount_information_internal_information_discount_applied_label"
                />
                <VEntry
                  :data="transactionDetails"
                  field="discountInfo.discountReason"
                  name="transactions.discount_information_discount_reason_discount_reason_label"
                />
                <VEntryNumber
                  currency-field="currency"
                  :digits="6"
                  :data="transactionDetails"
                  field="discountInfo.transcationUndiscountedGrossCharge"
                  name="transactions.discount_information_internal_information_gross_amount_without_discount_label"
                />
              </VGroup>
            </VDescriptionListDivided>
          </VSection>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VSection from '@/components/Section';
import VDescriptionList from '@/components/DescriptionList';
import VDescriptionListDivided from '@/components/DescriptionList/Divided';
import VGroup from '@/components/DescriptionList/Group';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryNumber from '@/components/DescriptionList/EntryNumber';

export default {
  name: 'PaymentTransactionsDetailsPrices',

  components: {
    VSection,
    VDescriptionList,
    VDescriptionListDivided,
    VGroup,
    VEntry,
    VEntryNumber,
  },

  props: {
    transactionDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapGetters('transactions', ['isExpertMode']),

    types() {
      const types = [
        { label: 'retail_price_booked_headline', field: 'retailChargeBooked' },
        { label: 'wholesale_price_booked_headline', field: 'wholesaleChargeBooked' },
      ];
      if (this.isExpertMode) {
        types.push({ label: 'retail_price_authorized_headline', field: 'retailChargeAuthorized' });
        types.push({ label: 'wholesale_price_authorized_headline', field: 'wholesaleChargeAuthorized' });
      }
      return types;
    },
  },
};
</script>
